import './entity-list.scss';

import { EntityDataStore } from '@skinsoft/entity-data-store';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { EntityFeaturedList, EntityHistory, Featured } from '@skinsoft/ui';
import { Component } from 'vue-property-decorator';

import { Movement, MovementDataStore, MovementTypes, Task } from '@skinsoft/entity';
import { CREATE_MOVEMENT_TOPIC } from '../../../busTopics';
import { router, Routes } from '../../../router';
import { CreateMovementModal } from '../../component/create-movement-modal';

@Component({
    components: {
        sCreateMovementModal: CreateMovementModal,
    },
    props: ['entityDataStore', 'entityFeaturedList', 'entityHistory', 'targetRouteName'],
    template: require('./entity-list.html'),
})
export class EntityList extends ReactiveVue {
    public entityDataStore: EntityDataStore<any>;
    public entityFeaturedList: EntityFeaturedList<Task | Movement>;
    public entityHistory: EntityHistory<Task | Movement>;
    public targetRouteName: string;

    public featureds: Array<Featured | null> = [];
    public items: Featured[] = [];

    public $refs: {
        createMovementModal: CreateMovementModal;
    };

    public created() {
        this.subscribeToBus(CREATE_MOVEMENT_TOPIC, this.onCreateMovement.bind(this));
    }

    private onCreateMovement() {
        this.$refs.createMovementModal.open();
    }
}
